class RegularService {
  constructor(id, name, typ, price, priceWithFee) {
    this.id = id;
    this.name = name;
    this.typ = typ;
    this.price = price;
    this.priceWithFee = priceWithFee;
  }
}

export default RegularService;
